"use client";
import React from "react";
import { TextFieldProps } from "@mui/material/TextField";
import { WcInternalMaskedTextfield, MaskProps } from "./WcInternalMaskedTextfield";

export type WcMaskedTextfieldProps = TextFieldProps & {
  controlDisabled?: boolean;
  useFullWidth?: boolean;
  mask?: MaskProps;
};

export const WcMaskedTextfield = ({
  useFullWidth = true,
  controlDisabled,
  value,
  sx,
  mask,
  ...props // Non-mask props
}: WcMaskedTextfieldProps) => (
  //@ts-ignore
  <WcInternalMaskedTextfield
    slotProps={{ ...props.slotProps }}
    fullWidth={useFullWidth}
    disabled={controlDisabled}
    value={value || ""}
    error={props.error}
    required={props.required}
    onAccept={props.onChange}
    {...props} // Spread non-mask props first
    {...mask} // Apply the mask prop directly
    sx={[...(Array.isArray(sx) ? sx : [sx])]}
  />
);

export default WcMaskedTextfield;
